import styled from "styled-components";
import { Paragraph, Heading } from "../../../atoms/Typography/Typography.styles";

interface HeroPrimaryProps {
  colorScheme?: string;
}

export const HeroPrimary = styled.div<HeroPrimaryProps>`
  padding: ${({ theme }) => theme.rem(32, 0)};
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme || 'darkGreen'].surface.inside};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme || 'darkGreen'].surface.text.base.primary};
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(60, 0)};
  `)}
`;

export const HeroPrimaryIconWrapper = styled.div`
  i {
    font-size: ${({ theme }) => theme.rem(16)};
  }
`;

export const HeroPrimaryImageWrapper = styled.div`
  width: 100%;
  max-height: ${({ theme }) => theme.rem(500)};
  position: relative;
  aspect-ratio: 4 / 4;
  margin-bottom: ${({ theme }) => theme.rem(24)};
  border-radius: ${({ theme }) => theme.rem(8)};
  overflow: hidden;
  
  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(40, 0)};
  `)}

  ${({ theme }) => theme.mediaQuery.lg(`
    margin-bottom: ${theme.rem(0)};
  `)};

  ${({ theme }) => theme.mediaQuery.xl(`
    max-height: none;
  `)};
  
  img {
    object-fit: cover;
    object-position: center;
  }
`;
